import { lazy } from "react";

const DashboardV2 = lazy(() => import("features/Dashboard/v2"));
const PortfolioV2Detail = lazy(() => import("features/Dashboard/v2/Detail"));
const PortfolioManage = lazy(() =>
  import("features/Dashboard/v2/SurmountAccountManage")
);

export const HOME_PATH = "/";
export const DASHBOARD_PATH = "/dashboard";
export const DASHBOARD_DETAIL_PATH = "/dashboard/:id/detail";
export const DASHBOARD_DETAIL_ID_PATH = "/dashboard/:id/detail/:detailId";
export const DASHBOARD_SURMOUNT_MANAGE_PATH =
  "/dashboard/:id/surmount-account-management";

// V2 Routes
export const DASHBOARD_V2_DETAIL_PATH = "/dashboard/:id/detail";
export const DASHBOARD_V2_DETAIL_ID_PATH = "/dashboard/:id/detail/:detailId";

export const dashboardRoutesV2 = [
  {
    path: DASHBOARD_SURMOUNT_MANAGE_PATH,
    component: <PortfolioManage />,
  },
  {
    path: DASHBOARD_V2_DETAIL_PATH,
    component: <PortfolioV2Detail />,
  },
  {
    path: DASHBOARD_PATH,
    component: <DashboardV2 />,
  },
  {
    path: DASHBOARD_V2_DETAIL_ID_PATH,
    component: <PortfolioV2Detail />,
  },
  {
    path: HOME_PATH,
    component: <DashboardV2 />,
  },
];
